// extracted by mini-css-extract-plugin
export default {"failed":"Failed_failed__-O0-K","failed__icon":"Failed_failed__icon__WBHqz","failed__telegram":"Failed_failed__telegram__egdNN"};